import './styles.scoped.css'
import {useState, useEffect} from 'react'
import {Typography, Snackbar, Alert, Slide} from '@mui/material'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'

const DEFAULT_DURATION = 3000

// A message may set `duration` (ms) when it needs longer to read; everything else keeps the default.
export default () => {
    const {messageBox, setMessageBox} = useGlobalStates()
    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (messageBox) {
            setOpen(true)
        }
    }, [messageBox])

    const handleClose = () => {
        setOpen(false)
        setTimeout(() => {
            setMessageBox(null)
        }, 500)
    }

    return (
        <Snackbar
            open={open}
            autoHideDuration={messageBox?.duration ?? DEFAULT_DURATION}
            onClose={handleClose}
            slots={{transition: SlideDown}}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
        >
            <div className="container">
                <Alert severity={messageBox?.status} variant="filled">
                    <Typography variant="alertTitle">{messageBox?.title} </Typography>
                    <Typography variant="body2">{messageBox?.description}</Typography>
                </Alert>
            </div>
        </Snackbar>
    )
}

const SlideDown = props => {
    return <Slide {...props} direction="down" />
}
